class PredictiveSearchHint {
  static HINT_SELECTOR = '.predictive-search-hint__text';
  static SEARCH_EVENT = 'concierge:search';

  constructor() {
    this.cachedResults = {};
    this.hintTextElement = null;
    this.hintData = null;
    this.abortController = null;

    // Always start watching for the element
    this.startWatching();

    this.setupSearchEventListener();
    //this.bindEvents();
  }

  setupSearchEventListener() {
    const debouncedFetchHint = debounce(async (searchTerm) => {
      // Create cache key
      const cacheKey = searchTerm.toLowerCase().trim();

      if (this.cachedResults[cacheKey]) {
        this.hintData = this.cachedResults[cacheKey];
        window.ConciergeChat.lastSearchHint = this.hintData;
        this.updateElement();
        return;
      }

      // Abort previous request if still pending
      if (this.abortController) {
        this.abortController.abort();
      }

      this.abortController = new AbortController();

      const hint = await this.fetchHint(searchTerm, this.abortController.signal);

      if (hint && hint.response) {
        this.hintData = hint.response;

        // Cache the result
        if (this.hintData.nudgeMessage) {
          this.cachedResults[cacheKey] = this.hintData;
        }

        window.ConciergeChat.lastSearchHint = this.hintData;
        this.updateElement();
      }
    }, 300);

    document.addEventListener(PredictiveSearchHint.SEARCH_EVENT, (event) => {
      if (event.detail && event.detail.searchTerm) {
        debouncedFetchHint(event.detail.searchTerm);
      }
    });
  }

  getStoreKey() {
    if (typeof window === 'undefined') {
      return '';
    }

    let storeKey = window.ConciergeChat?.shopDomain || window.Shopify?.shop || '';

    if (storeKey.endsWith('.myshopify.com')) {
      storeKey = storeKey.replace('.myshopify.com', '');
    }

    return storeKey;
  }

  getDomainUrl = () => {
    if (typeof window === 'undefined') {
      return '';
    }

    const config = window.ConciergeChat;
    const domain = config?.serverApiDomain || 'concierge.koala.com';

    if (domain.startsWith('http')) {
      return domain;
    }

    return `https://${domain}`;
  };

  startWatching() {
    this.observer = new MutationObserver((mutationsList, observer) => {
      // Check for the element on any childList mutation
      this.hintTextElement = document.querySelector(PredictiveSearchHint.HINT_SELECTOR);

      if (this.hintTextElement) {
        console.warn('found element');
        if (this.hintData) {
          this.updateElement();
        }
        observer.disconnect();
        this.observer = null;
      }
    });

    this.observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  updateElement() {
    const hintElements = document.querySelectorAll(PredictiveSearchHint.HINT_SELECTOR);
    if (hintElements.length > 0 && this.hintData && this.hintData.nudgeMessage) {
      hintElements.forEach((element) => {
        element.innerHTML = `<div class="fade-in">${this.hintData.nudgeMessage}</div>`;
      });
    }
  }

  async fetchHint(searchQuery, signal) {
    if (!searchQuery) {
      return null;
    }

    try {
      const domainUrl = this.getDomainUrl();
      const storeKey = this.getStoreKey();
      const { timeZone, locale } = Intl.DateTimeFormat().resolvedOptions();
      const response = await fetch(`${domainUrl}/api/search-hint`, {
        body: JSON.stringify({
          context: {
            query: searchQuery,
            timezone: timeZone,
            locale,
          },
        }),
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Concierge-Store-Key': storeKey,
        },
        signal: signal,
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      if (window.polar) {
        window.polar.track('Concierge Search Hint Fetched', {
          url: window.location.pathname,
          query: searchQuery,
        });
      }

      const data = await response.json();
      return data;
    } catch (error) {
      if (error.name === 'AbortError') {
        return null;
      }
      console.error('Error fetching hint:', error);
      return null;
    }
  }
}

// Initialization logic
function initializeComponent() {
  window.predictiveSearchHintInstance = new PredictiveSearchHint();
}

// Initialize when the DOM is ready or immediately if it already is.
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeComponent);
} else {
  initializeComponent();
}
